import React from 'react'
import styled from "styled-components"
import media from "styled-media-query"

import summerImg from "../../image/summer.JPG"
import winterImg from "../../image/winter.JPG"
import testImg from "../../image/test1000.JPG"

const IntroEvents = () => {

   return (
      <IntroEventsStyles
         id="events"
         summerImg={summerImg}
         winterImg={winterImg}
         testImg={testImg}
      >
         <h3>講習・イベント</h3>
         <div className="events-wrap">
            <div className="event summer">
               <h4>夏期講習</h4>
               <p>夏期講習では、前期の復習や後期 の成績アップへ向けての予習など を行います。</p>
            </div>
            <div className="event winter">
               <h4>冬季講習</h4>
               <p>冬期講習では、後期の復習などを 行います。また、受験学年は入試 へ向けた対策が大詰めとなります。</p>
            </div>
            <div className="event test">
               <h4>1000題テスト</h4>
               <p>中3生を対象とした、クリスマスに英語、大晦日に数学の問題を1000題解くイベントです。</p>
            </div>
         </div>
      </IntroEventsStyles>
   )
}

const IntroEventsStyles = styled.section`
   background-color: #FF8787;
   h3 {
      color: #fff;
   }
   .events-wrap {
      width: 100%;
      max-width: 1580px;
      margin: 40px auto;
      display: flex;
      justify-content: space-evenly;
      ${media.lessThan("600px")`
         width: 90%;
         margin-top: 24px;
         flex-direction: column;
      `}
      .event {
         width: 30%;
         max-width: 400px;
         background-color: #fff;
         color: #FF3D01;
         border-radius: 10px;
         box-shadow: 5px 5px 10px #000000;
         overflow: hidden;
         ${media.lessThan("600px")`
            width: 100%;
            margin: 30px auto 0;
         `}
         &:first-child {
            ${media.lessThan("600px")`
               margin-top: 0;
            `}
         }
         &:before {
            display: block;
            content: "";
            background-size: cover;
            width: 100%;
            height: 160px;
         }
         h4 {
            height: 40px;
            font-size: 1.8rem;
            line-height: 40px;
            text-align: center;
         }
         p {
            width: 100%;
            min-height: 120px;
            border-top: 1px solid;
            font-size: 1.4rem;
            line-height: 2rem;
            padding: 15px 30px;
         }
      }
      .summer {
         &:before {
            background-image: url(${({summerImg}) => summerImg});
         }
      }
      .winter {
         &:before {
            background-image: url(${({winterImg}) => winterImg});
         }
      }
      .test {
         &:before {
            background-image: url(${({testImg}) => testImg});
         }
      }
   }
`

export default IntroEvents